import { render, staticRenderFns } from "./GameLog.vue?vue&type=template&id=0b4f5a10&scoped=true&"
import script from "./GameLog.vue?vue&type=script&lang=js&"
export * from "./GameLog.vue?vue&type=script&lang=js&"
import style0 from "./GameLog.vue?vue&type=style&index=0&id=0b4f5a10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4f5a10",
  null
  
)

export default component.exports